import { ThemeProvider } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import App from "./App";
import HomePage from "./pages/HomePage";
import reportWebVitals from "./reportWebVitals";
import "./stylesheets/global.scss";
import theme from "./theme";

// Polyfill Math.pow to support BigInt values to prevent cosmjs / stargate crashes
/* global BigInt */
const originalPow = Math.pow;

function bigintPow(base, exponent) {
  let result = 1n;
  const b = BigInt(base);
  const e = BigInt(exponent);
  for (let i = 0n; i < e; i++) {
    result *= b;
  }
  return result;
}

Math.pow = function (base, exponent) {
  if (typeof base === "bigint" || typeof exponent === "bigint") {
    try {
      return bigintPow(base, exponent);
    } catch (e) {
      return originalPow(Number(base), Number(exponent));
    }
  }
  return originalPow(base, exponent);
};

const root = ReactDOM.createRoot(document.getElementById("root"));

const router = createBrowserRouter([
  {
    path: "/*",
    element: <App />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
]);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
